const INITIAL_GAP = 1000;
const MIN_GAP = 1;

/**
 * Fractional ordering (like a linked list of gaps) so moving one item only
 * ever requires updating that one row — no cascading renumbers of siblings.
 */
export function positionForIndex(index: number): number {
  return (index + 1) * INITIAL_GAP;
}

export function positionBetween(before: number | null, after: number | null): number {
  if (before == null && after == null) return INITIAL_GAP;
  if (before == null) return after! / 2;
  if (after == null) return before + INITIAL_GAP;
  return (before + after) / 2;
}

/**
 * True once repeated inserts between the same two neighbors have squeezed
 * the gap too thin to reliably split again (floating point precision floor).
 */
export function needsRebalance(orderedPositions: number[]): boolean {
  for (let i = 0; i < orderedPositions.length - 1; i += 1) {
    if (orderedPositions[i + 1] - orderedPositions[i] < MIN_GAP) return true;
  }
  return false;
}
